module.exports = __webpack_public_path__ + "img/t_2.4c9e0485.jpg";